import React from 'react';
import {ICON_TYPES} from './constants';
import * as ExportedIcons from './Icons';
import {datadogLogs} from '@datadog/browser-logs';

export type SVGType = (typeof ICON_TYPES)[keyof typeof ICON_TYPES];

export interface SVGIconProps extends React.SVGAttributes<SVGElement> {
  /**
   * text specifying type of svg icon to display
   */
  type: SVGType;
}

const Icons: Record<string, React.FC> = Object.values(ExportedIcons).reduce(
  (accumulator: any, item) => {
    accumulator[item.iconType] = item;
    return accumulator;
  },
  {}
);

const detectUnknown = (type: string): void => {
  datadogLogs.logger.error(`UnknownIconError:${type}`);
};

const UnknownIcon = () => <></>;

export default function SVGIcons({type, ...props}: SVGIconProps): JSX.Element {
  const Icon = Icons[type] ?? detectUnknown(type) ?? UnknownIcon;
  return <Icon {...props} />;
}
